import { useSubscriptionCookie } from 'hooks/use-subscription-cookie'
import { withAuthUser } from 'next-firebase-auth'

/**
 * Component that manages subscription cookie for server-side consumption
 * This component should be placed inside the Redux provider to access subscription state
 */
const SubscriptionCookieManager = (): null => {
  // This hook will automatically set the cookie when subscription info is loaded
  useSubscriptionCookie()

  // This component doesn't render anything
  return null
}

export default withAuthUser()(SubscriptionCookieManager)
